module.exports = __webpack_public_path__ + "img/organization2.cafcdbb9.png";